type UserLike = {
  teamId?: string | null
  teamLeadOf?: Array<{ id: string } | null | undefined> | null
} | null

/**
 * Members have `teamId`. Team leads are often only linked via `teamLeadOf[0].id`
 * with `teamId` null — without this, URLs become …/registrering/null.
 */
export function getEffectiveTeamId(user: UserLike): string {
  if (!user) return ''
  if (user.teamId) return user.teamId
  return user.teamLeadOf?.[0]?.id ?? ''
}
